import * as React from "react";
import Form from "react-bootstrap/Form";

function PasswordField({ locals }) {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Form.Control
        type={showPassword ? "text" : "password"}
        placeholder={locals.config.placeholder}
        onChange={(value) => locals.onChange(value.target.value)}
        className={locals.hasError && "dangerClass"}
        value={locals.value}
        className="formcntrl"
        style={{
          backgroundColor: "#d2d2d2",
          Color: "black",
          paddingRight: "40px",
        }}
      />

      <button
        type="button"
        onClick={() => setShowPassword((prevState) => !prevState)}
        aria-label={showPassword ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          right: "10px",
          border: "none",
          background: "transparent",
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#5c6873",
          cursor: "pointer",
          verticalAlign: "middle",
        }}
      >
        <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`} />
      </button>
    </div>
  );
}

function myCustomTemplate(locals: Object) {
  const isPasswordField = locals.config.type === "password";

  return (
    <Form.Group
    // controlId="formPlaintextPassword"
    >
      <Form.Label style={{ fontSize: 14 }}>{locals.config.label}</Form.Label>

      {isPasswordField ? (
        <PasswordField locals={locals} />
      ) : (
        <Form.Control
          // size="sm"
          type="text"
          placeholder={locals.config.placeholder}
          onChange={(value) => locals.onChange(value.target.value)}
          className={locals.hasError && "dangerClass"}
          value={locals.value}
          className="formcntrl"
          style={{ backgroundColor: "#d2d2d2", Color: "black" }}
        />
      )}

      {locals.hasError && (
        <p className="errormessage">{locals.config.errorMessage}</p>
      )}
    </Form.Group>
  );
}
export default myCustomTemplate;
